import script from "./ViewEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEvent.vue?vue&type=script&setup=true&lang=js"

import "./ViewEvent.vue?vue&type=style&index=0&id=5468bd8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5468bd8c"]])

export default __exports__